import React, { useContext } from "react";
import FormDataContext, { initialFormData } from "./formContext";

function FinishPopup() {
  let { finishPopup, setFinishPopup, setStep, setData } =
    useContext(FormDataContext);
  return (
    <>
      {finishPopup && (
        <div className="popupContainer">
          <div className="popup" role="status">
            <span>
              Thank you — your application has been submitted. Our team will
              review it and get back to you by email.
            </span>
            <div className="popupButtonsContainer">
              <button
                type="button"
                className="primaryButton"
                onClick={() => {
                  setFinishPopup(false);
                  setStep(1);
                  // Reset with the live field list; the old hard-coded reset
                  // listed fields the form no longer has, so real answers
                  // (father name, GPA, interests…) survived into the next one.
                  setData(initialFormData);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FinishPopup;
